import React from "react";
import CurrencyFormat from "react-currency-format";

const Price = ({ value, currencyCode, exchangeRate, token }) => {
  if (token !== "£") {
    token = token + " ";
  }
  if (currencyCode !== "GBP") {
    value = (value * exchangeRate).toFixed(2);
  }
  return (
    <CurrencyFormat
      value={value}
      displayType={"text"}
      thousandSeparator={true}
      prefix={token}
    />
  );
};

export default Price;
